import familyTitleArt from '../../assets/family-title-1.png';

type FamilyMembersTitleIconProps = {
  className?: string;
};

/** Artwork bounds after background removal (512×512 PNG). */
const FAMILY_TITLE_VIEWBOX = '1 9 494 492';

/**
 * Absolutely positioned inside AppPageTitleSection — must not affect section height.
 * top: 5px below AppTopBar (page py-6 = 1.5rem cancels out).
 * bottom: 5px above section divider (border-b).
 * No mix-blend — PNG uses transparency so light/dark share identical size and color.
 */
export const FamilyMembersTitleIcon = ({ className = '' }: FamilyMembersTitleIconProps) => (
  <div
    className={[
      'pointer-events-none absolute top-[calc(5px-1.5rem)] bottom-[5px] right-0 z-0 w-auto max-w-[10.5rem]',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    aria-hidden
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={FAMILY_TITLE_VIEWBOX}
      preserveAspectRatio="xMaxYMin meet"
      className="block h-full w-auto"
    >
      <image href={familyTitleArt} width="512" height="512" />
    </svg>
  </div>
);
